import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {plainToClass} from "class-transformer";
import {DtoManagementSalesGoalFilter} from "./models/DtoManagementSalesGoalFilter";
import {DtoManagementSalesGoal} from "./models/DtoManagementSalesGoal";
import {DtoManagementSalesGoalBaseItems} from "./models/DtoManagementSalesGoalBaseItems";

@Injectable()
export class ManagementSalesGoalService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getSalesGoal = (filter: DtoManagementSalesGoalFilter): Observable<DtoManagementSalesGoal> => {
        return this.http.post<DtoManagementSalesGoal>(`${this.apiUrl}/salesgoal/`, filter);
    };

    public getSalesGoalBaseItems = (): Observable<DtoManagementSalesGoalBaseItems> => {
        return this.http.get<DtoManagementSalesGoalBaseItems>(`${this.apiUrl}/salesgoal/baseitems`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/sales-goal/management-sales-goal.service.ts